import React, { Component } from 'react'
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";
import Card from "react-bootstrap/Card";
import L_EMClogo from "../../assets/img/experience/EMClogo.svg";
import L_logofamz from "../../assets/img/experience/logofamz.svg";
import L_logoDIT from "../../assets/img/experience/logoDIT.svg"
import "./experience.style.css";
import("react-facebook-pixel");

export class Experience extends Component {
  
    render() {
        return (
            <div id="experience">
            <h1 className="pt-3 text-center font-details-b pb-3">EXPERIENCE</h1>
            
            {/* Experience 1 - iOLPay */}
            <Jumbotron className="jumbo-style">
              <Container>
                <>
                  <Card>
                    <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                      <a className="text-dark text-decoration-none" href="https://iolpay.com/" target="_blank" rel="noopener noreferrer">
                        <Card.Img variant="top" className="img-resize" src="https://www.google.com/s2/favicons?domain=iolpay.com&sz=128" alt="iOLPay" />
                      </a>
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center flex-column">
                      <div>
                        <Card.Title className="text-center">Senior Software Engineer</Card.Title>
                      </div>
                      <div>
                        <Card.Text className="text-center style">
                          <br />
                          <strong>Languages & Technologies:</strong> Next.js 16+, React 19+, TypeScript, TanStack React Query, Zustand, Material UI, Tailwind CSS, .NET Core, PostgreSQL, Elasticsearch, MS Azure
                          <br />
                          <strong>Duration:</strong> April 2022 - Present
                          <br />
                          <strong>Location:</strong> Dubai, UAE (Remote)
                          <br />
                          <strong>Description</strong>
                          <ul className="text-left">
                            <li>Lead end-to-end delivery across frontend and backend — architecture, technical direction, and code quality across the full stack.</li>
                            <li><strong>Payment APIs:</strong> Designed and built iOLPay Payment APIs (Core) — unified .NET Core / PostgreSQL platform integrating Checkout.com, Oracle (OPERA Cloud / OWS / OHIP), Citibank, HSBC, Stripe, NIUM, and Currency Cloud.</li>
                            <li><strong>Products:</strong> iOL Pay Portal (merchant onboarding, transactions, refunds, disputes, AI dashboard insights), iOLPay Checkout (hosted + embeddable widget), Mastercard Priceless™ Booking Engine.</li>
                            <li><strong>AI:</strong> Shipped iOLPay AI Dashboard Insights — structured summaries (Headline, Key Insights, Anomalies) and guided / free-form Q&amp;A on live filtered data.</li>
                            <li>Apply Clean Architecture and DDD across .NET Core APIs; Power BI integrations; daily use of Cursor AI, ChatGPT, and Claude for delivery.</li>
                          </ul>
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              </Container>
            </Jumbotron>

            {/* Experience 2 - Welbee (Senior Full-Stack, FTE) */}
            <Jumbotron className="jumbo-style">
              <Container>
                <>
                  <Card>
                    <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                      <a className="text-dark text-decoration-none" href="https://welbee.co.uk/" target="_blank" rel="noopener noreferrer">
                        <Card.Img variant="top" className="img-resize" src="https://welbee.co.uk/wp-content/uploads/2025/01/Welbee-New-Logo-copy.png" alt="Welbee logo" />
                      </a>
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center flex-column">
                      <div>
                        <Card.Title className="text-center">Senior Full-Stack Developer (Full-Time)</Card.Title>
                      </div>
                      <div>
                        <Card.Text className="text-center style">
                          <br />
                          <strong>Languages & Technologies:</strong> .NET Core, React, GCP (BigQuery, Dataform), MySQL, microservices
                          <br />
                          <strong>Duration:</strong> March 2021 - April 2022
                          <br />
                          <strong>Location:</strong> Liverpool, UK (Remote)
                          <br />
                          <strong>Description</strong>
                          <ul className="text-left">
                            <li>Scaled Welbee&apos;s survey and wellbeing product suite for UK schools, colleges, universities, and Multi-Academy Trusts (MATs).</li>
                            <li>Built React frontends and .NET Core APIs across monolithic and microservice architectures with modern component patterns.</li>
                            <li>Integrated Google Cloud Platform services including BigQuery and Dataform for large-scale educational analytics.</li>
                          </ul>
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              </Container>
            </Jumbotron>

            {/* Experience 3 - Welbee (Team Lead, contract) */}
            <Jumbotron className="jumbo-style">
              <Container>
                <>
                  <Card>
                    <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                      <a className="text-dark text-decoration-none" href="https://welbee.co.uk/" target="_blank" rel="noopener noreferrer">
                        <Card.Img variant="top" className="img-resize" src="https://welbee.co.uk/wp-content/uploads/2025/01/Welbee-New-Logo-copy.png" alt="Welbee logo" />
                      </a>
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center flex-column">
                      <div>
                        <Card.Title className="text-center">Team Lead (Part-Time / Contract)</Card.Title>
                      </div>
                      <div>
                        <Card.Text className="text-center style">
                          <br />
                          <strong>Languages & Technologies:</strong> .NET Core, Python, React, GCP (BigQuery, Dataform, Cloud Composer / Airflow, Cloud Functions, Pub/Sub), Looker, Cube, LLM APIs
                          <br />
                          <strong>Duration:</strong> April 2022 - December 2025
                          <br />
                          <strong>Location:</strong> Liverpool, UK (Remote)
                          <br />
                          <strong>Description</strong>
                          <ul className="text-left">
                            <li><strong>EDU Intelligent:</strong> AI-powered MAT-level analytics — General Summary and &quot;Differences between Schools&quot; from Pulse and Online Safety surveys (Staff, Parents, Carers).</li>
                            <li><strong>Data platform:</strong> BigQuery warehouse, Dataform SQLX transformations, Cloud Composer (Airflow) orchestration; Wonde integration syncing MIS data into BigQuery.</li>
                            <li><strong>Microservices:</strong> Event-driven processing with Cloud Functions and Pub/Sub for survey events and notifications.</li>
                            <li><strong>Reporting:</strong> Looker dashboards and Cube semantic layer feeding the AI summary engine.</li>
                            <li>Led developers through architecture, code reviews, and delivery; introduced AI-augmented workflows (Cursor AI, ChatGPT, Claude) with prompt patterns and guardrails.</li>
                          </ul>
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              </Container>
            </Jumbotron>

            {/* Experience 4 - Emcentrix */}
            <Jumbotron className="jumbo-style">
              <Container>
                <>
                  <Card>
                    <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                    <a className="text-dark text-decoration-none" href="https://www.emcentrix.com/" target="_blank" rel="noopener noreferrer">
                    <Card.Img variant="top" className="img-resize" src={L_EMClogo} alt="Emcentrix logo" />
                            </a>
                      
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center flex-column">
                      <div>
                        <Card.Title className="text-center">Senior Software Engineer / .NET Developer</Card.Title>
                      </div>
                      <div>
                        <Card.Text className="text-center style">
                          <br />
                          <strong>Languages & Technologies:</strong> ASP.NET Core, ASP.NET MVC, Web Forms, .NET, Entity Framework, React JS, C#, MS SQL, JavaScript, jQuery
                          <br />
                          <strong>Duration:</strong> May 2013 - March 2021
                          <br />
                          <strong>Location:</strong> Olympia, USA
                          <br/>
                          <strong>Description</strong>
                          <ul className="text-left">
                            <li>Drove modernization and service-level enhancements across information systems, data center operations, database design, and application development.</li>
                            <li><strong>Application development:</strong> Delivered robust .NET applications and improved stability through automation and shell-script tooling.</li>
                            <li><strong>Web development:</strong> Production web applications with strong cross-browser, cross-device, and SEO compatibility.</li>
                            <li><strong>Quality assurance:</strong> Test plans, test cases, and functional, regression, and integration testing.</li>
                            <li><strong>Database design:</strong> Physical database design and access strategies aligned to project requirements.</li>
                            <li><strong>Documentation:</strong> Technical and user-facing documentation with stakeholder clarity and confidentiality.</li>
                          </ul>
                        </Card.Text>
                      </div>
                    </Card.Body>

              
                  </Card>
                </>
              </Container>
            </Jumbotron>
            {/* Experience 5 - Famz Solutions */}
            <Jumbotron className="jumbo-style">
              <Container>
                <>
                  <Card>
                    <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                    <a className="text-dark text-decoration-none" href="http://www.famzsolutions.com/" target="_blank" rel="noopener noreferrer">
                    <Card.Img variant="top" className="img-resize" src={L_logofamz} alt="Famzsolutions logo" />
                            </a>
                      
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center flex-column">
                      <div>
                        <Card.Title className="text-center">Software Engineer</Card.Title>
                      </div>
                      <div>
                        <Card.Text className="text-center style">
                          {/* <strong className="body-title-style ">Full Stack Developer</strong> */}
                          <br />
                          <strong>Languages & Technologies:</strong> ASP.NET, WebForm, DOTNET, C#, MS-SQL, ADO.NET, JavaScript,JQuery 
                          <br />
                          <strong>Duration:</strong> Jan 2013 - April 2013
                          <br/>
                          <strong> Description </strong>
                          <ul className="text-left">
                            <li>Conceptualized, developed and integrated new system and software, resulting in increasing efficiency record-keeping, higher
productivity as well as accuracy and effectiveness.
                            </li>
                            <li><strong>Application Designing & Development:</strong> Designed and tested applications enabling organizations and individuals to work
effectively. Consulted with clients, writing code, solving compatibility issues, updating development process records,
eliminating technical problems, and collaborating with the development team.
                            </li>

  

                            <li><strong>Testing Modules: </strong>  Directed all functions and activities associated with compliance to resource requirements for Testing &
Quality Assurance to ensure appropriate balance between tactical and strategic demands.
                            </li>
                            <li><strong>Database Analysis & Design: </strong> Competed technical challenges related to the test cases and test scripts derived from the
system documentation and technical functional specifications.
                            </li>

                           
                            
      
                          </ul>
                          
                          
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              </Container>
            </Jumbotron>


              {/* Experience 6 - Dera IT Solutions */}
              <Jumbotron className="jumbo-style">
              <Container>
                <>
                  <Card>
                    <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                    <a className="text-dark text-decoration-none" href="http://deraitsolutions.com/" target="_blank" rel="noopener noreferrer">
                    <Card.Img variant="top" className="img-resize" src={L_logoDIT} alt="DeraITSolution logo" />
                            </a>
                      
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center flex-column">
                      <div>
                        <Card.Title className="text-center">Junior Software Engineer</Card.Title>
                      </div>
                      <div>
                        <Card.Text className="text-center style">
                          <br />
                          <strong>Languages & Technologies:</strong> ASP.NET, WebForm, DOTNET, C#, MS-SQL, ADO.NET, JavaScript,JQuery 
                          <br />
                          <strong>Duration:</strong> December 2011 - January 2013
                          <br/>
                          <strong> Description </strong>
                          <ul className="text-left">
                            <li>Designed and implemented software systems; updated software systems, making improvement suggestions, collaborated with
analysts and designers, testing applications, writing training manuals, and making sure projects accomplished in time and within
budget.

                            </li>
                            <li><strong>Application Designing & Development:</strong> Designed and developed new applications and all Peripheral processes.

                            </li>

  

                            <li><strong>Learn new technologies: </strong>   Acquired and utilized knowledge of emerging technologies to utilize in engineering.

                            </li>
                          
                          </ul>
                          
                          
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </>
              </Container>
            </Jumbotron>
          </div>
        )
    }
}

export default Experience 
